// Import utils and helpers
import { ORDER_FULFILLMENT } from "@/utils/statusStyles";
import { Image } from "@/components/icons_new";
import { formatCurrency } from "@/utils/formatCurrency";
import { useOrderDetailsContext } from "../context/OrderDetailsContext";

// Import ihnouse icons
import { Fulfillment } from "@/components/icons_new";

const resolveStatusStyle = (map, status) => {
  if (!status) return map.unknown;

  const normalized = status.toLowerCase().replace(/\s+/g, "");
  const entry = Object.entries(map).find(([key]) => key.toLowerCase().replace(/\s+/g, "") === normalized);

  return entry ? map[entry[0]] : map.unknown;
};

export default function OrderProductSection() {
  const { order } = useOrderDetailsContext();

  if (!order) return null;

  const fulfillmentStyle = resolveStatusStyle(ORDER_FULFILLMENT, order.fulfillmentStatus);
  const totalItems = order.meta?.totalQuantity ?? order.items ?? 0;

  return (
    <div className="rounded-md border border-[#d2d2d2] bg-white p-4">
      {/* Fulfillment status */}
      <div className="mb-4 flex flex-wrap items-center gap-2">
        <span className={`rounded-full flex items-center gap-[5px] h-fit px-2 py-1 text-[0.8em] font-medium ${fulfillmentStyle.color}`}>
          <Fulfillment className="h-[1.2em] w-[1.2em]"/>
          {`${fulfillmentStyle.label} (${totalItems})`}
        </span>
      </div>

      {/* Product list */}
      <div className="space-y-4">
        {order.products.length === 0 && (
          <div className="rounded border border-dashed border-[#d1d5db] bg-[#f9fafb] p-4 text-sm text-[#6b7280]">
            No products attached to this order.
          </div>
        )}

        {order.products.map((product) => (
          <div
            key={product.variantComboId}
            className="flex items-start justify-between gap-4 border-b border-[#e5e7eb] pb-4 last:border-b-0 last:pb-0"
          >
            <div className="flex items-start gap-4">
              {/* Image of the product */}
              <div className="h-14 w-14 flex items-center justify-center overflow-hidden rounded  bg-[#e4e4e457]">
                {product.image || product.imageUrl ? (
                  <img
                    src={product.image || product.imageUrl}
                    alt={product.productName || "Product image"}
                    className="h-full w-full object-cover"
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = "/images/default-img.jpg";
                    }}
                  />
                ) : (
                  <Image className="h-5 w-5 text-[#969696a5]" />
                )}
              </div>

              <div className="">
                {/* Product name */}
                <span className="block font-medium text-sm text-[#333333]">{product.productName || "Unnamed product"}</span>

                {/* Product SKU */}
                <span className="block text-xs text-[#333333]">SKU: {product.sku || "N/A"}</span>

                {/* Product variant combo */}
                {/* TODO: Rename this to variant */}
                <span className="block text-xs text-[#333333]">Quantity: {product.quantity}</span>
              </div>
            </div>
            
            <div className="flex flex-col gap-[5px] text-sm font-medium text-[#333333]">
              <span>{`${product.quantity} x ${formatCurrency(product.unitPrice)}`}</span>
              <span className="font-semibold">{formatCurrency(product.total)}</span>
            </div>
          </div>
        ))}
      </div>
      
      {/* TODO: Make this dynamic */}
      <div className="mt-6 flex justify-end gap-3">
        <button className="rounded-[10px] border border-[#c6c6c6] bg-[#333333] px-[8px] py-[5px] text-sm font-medium text-[#ffffff] hover:bg-[#333333d8]">
          Fulfill items
        </button>
      </div>
    </div>
  );
}
